module.exports = __webpack_public_path__ + "img/calendar-26.cc5e6d09.svg";